import { Link } from 'react-router-dom';

export default function Footer() {
  const services = [
    { id: '1', title: 'Ticaret ve Şirketler Hukuku', slug: 'ticaret-sirketler-hukuku' },
    { id: '2', title: 'Gayrimenkul ve İnşaat Hukuku', slug: 'gayrimenkul-insaat-hukuku' },
    { id: '3', title: 'İş Hukuku ve Sosyal Güvenlik', slug: 'is-hukuku-sosyal-guvenlik' },
    { id: '4', title: 'Ceza Hukuku', slug: 'ceza-hukuku' },
    { id: '5', title: 'İcra ve İflas Hukuku', slug: 'icra-iflas-hukuku' },
    { id: '6', title: 'Tazminat Hukuku', slug: 'tazminat-hukuku' },
    { id: '7', title: 'Aile Hukuku', slug: 'aile-hukuku' },
    { id: '8', title: 'Miras Hukuku', slug: 'miras-hukuku' }
  ];

  const quickLinks = [
    { name: 'Ana Sayfa', href: '/' },
    { name: 'Hakkımızda', href: '/about' },
    { name: 'Hizmetler', href: '/services' },
    { name: 'İletişim', href: '/contact' }
  ];

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <i className="ri-scales-3-line text-2xl mr-3"></i>
              <span className="text-xl font-bold font-poppins">Hukuk Bürosu</span>
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed font-poppins font-light">
              Isparta'da 4+ yıllık deneyimimizle güvenilir ve profesyonel 
              hukuki danışmanlık hizmetleri sunuyoruz.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 font-poppins">Hizmetlerimiz</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.id}>
                  <Link 
                    to={`/services/${service.slug}`} 
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer font-poppins font-light"
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 font-poppins">Hızlı Bağlantılar</h3>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.href} 
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer font-poppins font-light"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 font-poppins">İletişim</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-lg mr-3 mt-1 flex-shrink-0"></i>
                <div className="text-gray-300 font-poppins font-light">
                  <div>Çelebiler Mah. 119. Cad.</div>
                  <div>No: 1 D: 6</div>
                  <div>Merkez / ISPARTA</div>
                </div>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-lg mr-3"></i>
                <div className="text-gray-300 font-poppins font-light">
                  <a 
                    href="tel:+905056055845" 
                    className="hover:text-white transition-colors cursor-pointer block"
                  >
                    0505 605 58 45
                  </a>
                  <a 
                    href="tel:+905541166976" 
                    className="hover:text-white transition-colors cursor-pointer block"
                  >
                    0554 116 69 76
                  </a>
                </div>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-lg mr-3"></i>
                <a 
                  href="mailto:info@ybhukukdanismanlik.com" 
                  className="text-gray-300 hover:text-white transition-colors font-poppins font-light cursor-pointer"
                >
                  info@ybhukukdanismanlik.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-300 text-sm font-poppins font-light">
            © 2024 Hukuk Bürosu. Tüm hakları saklıdır.
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://cdco.com.tr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-gray-300 text-sm transition-colors font-poppins font-light"
            >
              Bu web tasarımı CDCO tarafından yapılmıştır
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
